import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { Box, Button, IconButton, TextField, Tooltip } from '@material-ui/core'
import { Info as InfoIcon } from 'react-feather'
import { isEmpty } from 'lodash'

import useSnackbar from 'hooks/useSnackbar'

import useStyles from './styles'

const CreateNewField = ({
  companyFragilities,
  stagedFragilities,
  onStage,
  saving,
}) => {
  const [newFragilityName, setNewFragilityName] = useState('')

  const classes = useStyles()
  const snackbar = useSnackbar()

  const handleStage = () => {
    const trimmedName = newFragilityName.trim()
    if (isEmpty(trimmedName)) return

    const existingNames = [
      ...companyFragilities.map((item) => item.name),
      ...stagedFragilities.map((item) => item.name),
    ]
    const isDuplicated = existingNames.some(
      (name) => name?.trim().toLowerCase() === trimmedName.toLowerCase(),
    )

    if (isDuplicated) {
      snackbar.open({
        message: 'Já existe uma ameaça com esse nome',
        variant: 'error',
      })
      return
    }

    onStage({ name: trimmedName, isNew: true })
    setNewFragilityName('')
  }

  return (
    <Box className={classes.row}>
      <TextField
        className={classes.grow}
        label="Criar ameaça"
        variant="outlined"
        value={newFragilityName}
        onChange={(event) => setNewFragilityName(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault()
            handleStage()
          }
        }}
        InputProps={{
          endAdornment: (
            <Tooltip
              title="Para editar uma ameaça, acesse o submenu de Ameaças."
              placement="top"
              arrow
            >
              <IconButton size="small">
                <InfoIcon size={20} className={classes.infoIcon} />
              </IconButton>
            </Tooltip>
          ),
        }}
      />
      <Button
        variant="contained"
        color="primary"
        onClick={handleStage}
        disabled={isEmpty(newFragilityName.trim()) || saving}
      >
        Adicionar
      </Button>
    </Box>
  )
}

CreateNewField.propTypes = {
  companyFragilities: PropTypes.array,
  stagedFragilities: PropTypes.array,
  onStage: PropTypes.func.isRequired,
  saving: PropTypes.bool,
}

export default CreateNewField
